import { render, staticRenderFns } from "./SidebarBurger.vue?vue&type=template&id=18ba327c&"
import script from "./SidebarBurger.vue?vue&type=script&lang=js&"
export * from "./SidebarBurger.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBurger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports